import {
  IRequirementResponse,
  RequirementStatus
} from "@wingspanhq/payments/dist/interfaces";
import { selectorIsRequirementPostApproval } from "./selectorIsRequirementPostApproval";

export const selectorIsRequirementApproved = (
  requirement: IRequirementResponse
) => {
  const isRequirementComplete =
    requirement.status === RequirementStatus.Complete;

  return (
    selectorIsRequirementPostApproval(requirement) && isRequirementComplete
  );
};
